import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import { getChannels } from '../../../../../api/api';

import { Buttons } from '../buttons';

import Logo from '../../img/logo.svg';
import Telegram from '../../img/telegram.svg';

import * as styles from './index.module.scss';

const TELEGRAM_CHANNEL_ID = '3';
const TELEGRAM_CHANNEL_TYPE_ID = '1';

export const Footer = () => {
  const [telegramLink, setTelegramLink] = useState(null);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    getChannels().then((channels) => {
      const channel = channels?.find(
        ({ id, type_id }) => id === TELEGRAM_CHANNEL_ID && type_id === TELEGRAM_CHANNEL_TYPE_ID,
      );

      if (channel?.link) {
        setTelegramLink(channel.link);
      }
    });
  }, []);

  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.wrap}>
          <div className={styles.content}>
            <img src={Logo} className={styles.logo} alt="ZENIT" />
            <div className={styles.links}>
              <Buttons color="dark" className={styles.buttons} buttonClassName={styles.button} />
              <a
                href={telegramLink}
                target="_blank"
                className={classNames(styles.telegram, { [styles.disabled]: !telegramLink })}
                rel="noreferrer"
              >
                <img src={Telegram} alt="Telegram" />
                Telegram канал
              </a>
            </div>
          </div>
          <div className={styles.info}>
            <p className={styles.text}>
              Служба поддержки: <a href="tel:88002225550">8 (800) 222-55-50</a>
            </p>
            <p className={styles.text}>
              1998 - {currentYear} Букмекерская контора &laquo;Зенит&raquo;. &copy;&nbsp;Все права
              защищены
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
